import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ gap }) => gap || '0.5em'};
    ${({ align }) => align ? 'align-items: ' + align + ';' : null}
    ${({ justify }) => justify ? 'justify-content: ' + justify + ';' : null}
`

const Col = React.forwardRef(({ children, ...props }, ref) => {
    return (
        <Wrapper ref={ref} {...props}>
            {children}
        </Wrapper>
    );
});

export default Col;
